import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { FinancialAdvice } from "../../../Common/PaymentsIn/FinancialAdvice";
import { SinglePayment } from "../../../Common/PaymentsIn/SinglePayment/SinglePayment";
import { MoneyPurchaseAnnualAllowanceComponent } from "../../../Common/PaymentsIn/SIPP/MoneyPurchaseAnnualAllowanceComponent";
import { PensionProtection } from "../../../Common/PaymentsIn/SIPP/PensionProtection";
import { isRestrictedToPensionContribution } from "../../../Common/PaymentsIn/SIPP/ValidationHelper";
import { TransferIn } from "../../../Common/PaymentsIn/TransferIn/TransferIn";
import { InvalidDpcTransferWarningText, InvalidNonDpcTransferWarningText, IsRestrictedToPensionContributionWarningText, PaymentType, processTypeEnum } from "../../../Common/Resource/Contents";
import { RestrictionStore } from "../../../Common/Restrictions/Variable";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { PensionArrangementAction } from "../../../PortfolioDashboard/Components/ProductOverview/Action/PensionArrangementValuationAction";
import { PensionArrangementType } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { UserStore } from "../../../../../Stroes/Variable";
import { Action } from "../../../../../Actions/Action";
import { PensionContribution } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContribution";
import { PensionAnnuityAssumption } from "../../../Common/PaymentsIn/SIPP/PensionAnnuityAssumption";
import { BankAccountAction } from "../../../Common/PaymentsIn/BankAccount/BankAccountAction";

interface IPaymentsInProps extends IProcessComponentProps {
    type: SubAccountType;
    subaccountHierarchyId: string;
    data: any;
}

interface IPaymentsInState {
    transferInDisabled?: boolean;
    hasDrawdownArrangement?: boolean;
    hasDisqualifyingPensionCredit: boolean;
    userInfo: User;
}

export class PaymentsIn extends ProcessComponent<IPaymentsInProps, IPaymentsInState> {
    constructor(props: any) {
        super(props);
        this.state = {
            hasDrawdownArrangement: false,
            userInfo: UserStore.getUserInfo(),
            hasDisqualifyingPensionCredit: false
        };
    }
    componentDidMount() {
        super.componentDidMount();
        const { data } = this.props;
        this.setState({ transferInDisabled: RestrictionStore.transferDisabled() });
        if (this.props.type == SubAccountType.Npr) {
            PensionArrangementAction.GetPensionArrangementDetails(data?.OwnerHierarchyId, true, (v) => {
                this.setDrawdownArrangement(v);
            });
        }
        Action.getPensionSubAccountSettings(this.props.subaccountHierarchyId, true, (val) => {
            this.setState(
                {
                    hasDisqualifyingPensionCredit: val?.HasDisqualifyingPensionCredit ?? false
                }
            );
        });
    }

    private setDrawdownArrangement(arrangementDetails) {
        arrangementDetails.forEach(v => {
            if (v.Type != PensionArrangementType.Accumulation) {
                this.setState({ hasDrawdownArrangement: true });
            }
        });
    }
    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp, isReview } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
            hasPaymentMethod: true,
            isReview: isReview,
            onSaveNewBankAccountInstruction: (bankAccountInstruction) => {
                bankAccountInstruction.OwnerHierarchyId = data.OwnerHierarchyId;
                BankAccountAction.saveBankInstruction(
                    bankAccountInstruction,
                    data.ClientDetails?.ActorId,
                    processTypeEnum.SinglePaymentTransfer,
                    (savedBankAccountInstruction) => {
                        const changes = [...data.BankAccountInstructions, ...[savedBankAccountInstruction]];
                        this.onDataChange(onChange, changes, data, "BankAccountInstructions");
                    }
                );
            },
            onRemoveBankAccountInstruction: (bankAccountInstruction) => {
                BankAccountAction.removeBankInstruction(bankAccountInstruction, () => {
                    const changes = (data.BankAccountInstructions || []).filter(
                        (x) => x.AccountNumber != bankAccountInstruction.AccountNumber
                    );
                    this.onDataChange(onChange, { BankAccountInstructions: changes }, data);
                });
            },
        };
    };

    isValid() {
        const flag = super.isValid();
        var isRestrictedProtection = false;
        if (this.props.data?.Contribution?.HasPensionProtection && this.props.data?.Contribution?.PensionProtection) {
            isRestrictedProtection = isRestrictedToPensionContribution(
                this.props.data?.Contribution?.PensionProtection
            );
            if (isRestrictedProtection) {
                this.props.showErrorMsgPopUp([IsRestrictedToPensionContributionWarningText]);
            }
        }

        var passDpcCheck = true;
        if (this.props.type == SubAccountType.Npr) {
            var contribution = this.props.data?.Contribution as PensionContribution;
            var hasAnyDpcTransfer = contribution?.PensionTransfers?.some((t) => t.PensionDetails?.IsDisqualifyingPensionCredits);
            passDpcCheck = this.state.hasDisqualifyingPensionCredit == hasAnyDpcTransfer;

            if (!passDpcCheck && this.state.hasDisqualifyingPensionCredit) {
                this.props.showErrorMsgPopUp([InvalidNonDpcTransferWarningText]);
            }
            else if (!passDpcCheck && !this.state.hasDisqualifyingPensionCredit) {
                this.props.showErrorMsgPopUp([InvalidDpcTransferWarningText]);
            }
        }

        return flag && !isRestrictedProtection && passDpcCheck;

    }

    private renderPaymentsIn(ClientDetails, AllBankAccounts, BankAccountInstructions) {
        const { Contribution } = this.props.data;
        const { type } = this.props;
        const { onChange, data } = this.props;
        return (
            <>
                <hr />
                <MoneyPurchaseAnnualAllowanceComponent {...this.getProps("Contribution")} />
                <PensionProtection {...this.getProps("Contribution")} label={"Edit pension protection"} />
                <PensionAnnuityAssumption {...this.getProps("Contribution")} processType={ProcessType.TopUpWithITFLS} />
                <hr />
                <SinglePayment
                    {...this.getProps("Contribution")}
                    clientInfo={ClientDetails}
                    checkBoxOption={[
                        PaymentType.Client,
                        PaymentType.ThirdParty,
                        PaymentType.EmployerSalaryDeduction,
                        PaymentType.Employer,
                    ]}
                    hasPaymentMethod={true}
                    subAccountType={this.props.type}
                    bankAccounts={AllBankAccounts}
                    bankAccountInstructions={BankAccountInstructions}
                    processType={processTypeEnum.topUpWithITFLS}
                />
                <hr />
                {Contribution.PensionTransfers && (
                    <TransferIn
                        disabled={this.state.transferInDisabled}
                        subAccountType={type}
                        data={Contribution.PensionTransfers}
                        jouneryType={processTypeEnum.topUpWithITFLS}
                        onChange={(changes) =>
                            this.onDataChange(
                                (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                changes,
                                data.Contribution
                            )
                        }
                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                        isPost={false}
                        isReview={this.props.isReview}
                        onRef={(ref) => this.appendChild(ref)}
                        accountServiceProposition={this.props.data.AccountServiceProposition}
                    />
                )}
            </>
        );
    }

    public render(): JSX.Element {
        const { ClientDetails, AllBankAccounts, Contribution, BankAccountInstructions } = this.props.data;
        const { type } = this.props;
        return (
            <div>
                <h2>Payments in</h2>
                <FinancialAdvice {...this.getProps("Contribution")} processtype={ProcessType.TopUpWithITFLS} firstMovetoDrawdown={!this.state.hasDrawdownArrangement} />
                {(!this.state.userInfo?.IsAdviser || Contribution?.AdviceGiven || this.state.hasDrawdownArrangement) && Contribution?.AdviceGiven != null &&
                    this.renderPaymentsIn(ClientDetails, AllBankAccounts, BankAccountInstructions)}
            </div>
        );
    }
}
